import { render, staticRenderFns } from "./Shistorytable.vue?vue&type=template&id=e7a964ba"
import script from "./Shistorytable.vue?vue&type=script&lang=js"
export * from "./Shistorytable.vue?vue&type=script&lang=js"
import style0 from "./Shistorytable.vue?vue&type=style&index=0&id=e7a964ba&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports